<template>
  <transition name="fadeFooter" mode="out-in" appear>
    <div class="footer">
      <span class="footer-text license" style="margin-left: 10px;">WEEZIE FIBER @2025 {{ $t('LicensedTo') }} {{ host }} - {{ version }} </span>
      <div class="socials-container">
        <a class="footer-text" style="text-transform: lowercase;" href="https://weezie.io/" target="_blank">weezie.io</a>
        <a href="https://www.instagram.com/weezieofficial/" target="_blank">
          <v-badge
            :content="''"
            :value="null"
            color="accent"
            tile
            bordered
            dark
            overlap
            class="footer-badge"
          >
            <v-btn icon>
              <v-icon color="#231E46" size="24">mdi-instagram</v-icon>
            </v-btn>
          </v-badge>
        </a>
        <a href="https://www.facebook.com/weeziesoftware/" target="_blank">
          <v-badge
            :content="''"
            :value="null"
            color="accent"
            tile
            bordered
            dark
            overlap
            class="footer-badge"
          >
            <v-btn icon>
              <v-icon color="#231E46" size="24">mdi-facebook</v-icon>
            </v-btn>
          </v-badge>
        </a>
        <a href="https://www.twitter.com/weeziesoftware/" target="_blank">
          <v-badge
            :content="''"
            :value="null"
            color="accent"
            tile
            bordered
            dark
            overlap
            class="footer-badge"
          >
            <v-btn icon>
              <TwitterLogo />
            </v-btn>
          </v-badge>
        </a>
        <a href="https://www.linkedin.com/company/weezie-io/" target="_blank">
          <v-badge
            :content="''"
            :value="null"
            color="accent"
            tile
            bordered
            dark
            overlap
            class="footer-badge"
          >
            <v-btn icon>
              <v-icon color="#231E46" size="24">mdi-linkedin</v-icon>
            </v-btn>
          </v-badge>
        </a>
      </div>
    </div>
  </transition>
</template>

<script>
import TwitterLogo from "@/assets/logos/x-twitter.svg";

export default {
  name: "HubFooter",

  components: { TwitterLogo },

  props: {
    loading: {
      type: Boolean,
    },

    host: {
      type: String,
    },

    version: {
      type: String,
    },
  },
}
</script>

<style scoped>
.footer {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer-text {
  color: #231E46;
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px; /* 100% */
}

.footer-text.license {
  font-size: 12px;
}

.fadeFooter-enter {
  opacity: 0;
}

.fadeFooter-enter-active {
  transition: opacity 1s 0.5s;
}

.footer-badge {
  background: rgba(255, 255, 255, 0.50);
  border-radius: 4px;
  height: 32px;
  width: 32px;
  cursor: pointer;
  justify-content: center;
  display: flex;
  align-items: center;
  margin: 0 !important;
  box-shadow: 7px 9px 15px 0px rgba(0, 0, 0, 0.15) !important;
}

.footer-badge > .v-btn:before,
.footer-badge > .v-btn--active:not(:hover)::before,
.footer-badge > .v-btn:focus:before {
  background-color: transparent !important;
  opacity: 0;
}

.footer-badge > .v-btn >>> .v-ripple__container {
  display: none;
}

.socials-container {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-right: 10px;
}

@media only screen and (max-width: 750px) {
  .footer-text.license{
    display: none;
  }

  .footer {
    justify-content: center;
  }
}

@media only screen and (max-height: 500px) {
  .footer {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Hub/HubFooter.vue